import type { FailureKind, ModuleStatus, ModuleType, NeedKind, ShipClass, ShipPhase, SimErrorCode } from "@station-keeping/sim";
import { ApiError } from "../api/errors";
import { hasMessage, t } from "../i18n";

export function moduleName(type: ModuleType): string {
  return t(`module.${type}.name`);
}

export function moduleDescription(type: ModuleType): string {
  return t(`module.${type}.description`);
}

export function statusLabel(status: ModuleStatus): string {
  return t(`status.${status}`);
}

export function failureLabel(kind: FailureKind): string {
  return t(`failure.${kind}`);
}

export function stageLabel(stage: 1 | 2 | 3): string {
  return t(`failure.stage.${stage}`);
}

export function shipLabel(shipClass: ShipClass): string {
  return t(`ship.${shipClass}`);
}

export function phaseLabel(phase: ShipPhase): string {
  return t(`ship.phase.${phase}`);
}

export function needLabel(kind: NeedKind): string {
  return t(`need.${kind}`);
}

/** Message d'une erreur de la simulation (code stable), ou un message générique. */
export function errorLabel(code: SimErrorCode | string): string {
  const key = `error.${code}`;
  return hasMessage(key) ? t(key) : t("error.generic");
}

/** Message d'une erreur de l'API (code stable traduit), d'une coupure réseau, ou un message générique. */
export function apiErrorLabel(error: unknown): string {
  if (!(error instanceof ApiError)) return t("apiError.network");
  const attemptsLeft = error.details?.attemptsLeft;
  if (error.code === "CODE_INVALID" && typeof attemptsLeft === "number") {
    return t("apiError.CODE_INVALID.left", { count: attemptsLeft });
  }
  const key = `apiError.${error.code}`;
  if (hasMessage(key)) return t(key);
  return error.status === 429 ? t("apiError.TOO_MANY_REQUESTS") : t("apiError.generic");
}
